import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class NavigationService {

  private routeNavigationManager: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public openRoute: Observable<any>;

  private lassoNavigationManager: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public openLasso: Observable<any>;

  constructor() {
    this.openRoute = this.routeNavigationManager.asObservable();
    this.openLasso = this.lassoNavigationManager.asObservable();
  }

  navigateToRoute() {
    this.routeNavigationManager.next(true);
  }

  navigateToLasso() {
    this.lassoNavigationManager.next(true);
  }

}



// WEBPACK FOOTER //
// ./client/app/core/navigation/navigation.service.ts